import create from './http';
const CONFIG = {
  dev: '//pre-gapp.inuozhen.com/',
  qa: '//pre-gapp.inuozhen.com/',
  pre: '//pre-gapp.inuozhen.com/',
  prod: '//gapp.inuozhen.com/'
};
const env = process.env.VUE_APP_ENV;
const baseURL = CONFIG[env];
const service = create({ baseURL });
export default service;
